import { ClickAwayListener, Tooltip } from '@mui/material'
import { useState } from 'react'

import { InfoIcon } from '@f/elements/Icon/InfoIcon'

import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'
import { ClientOnly } from '@f-fertighaus/components/ClientOnly/ClientOnly'

import { WTPayload } from '../../../types/WTPayload'
import { InfoIconContainer } from './InfoTooltip.styled'

interface Props {
  title: string
  wtPayload: Omit<WTPayload, 'values' | 'category' | 'action'>
}

export const InfoTooltip = (props: Props) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)
  const handleOpenTooltip = () => {
    setIsTooltipOpen(true)
    webtrack({
      ...props.wtPayload,
      category: 'tooltip',
      action: 'click',
      values: [{ type: 'state', value: 'open' }]
    })
  }
  const handleCloseTooltip = () => {
    if (isTooltipOpen) {
      setIsTooltipOpen(false)
      webtrack({
        ...props.wtPayload,
        category: 'tooltip',
        action: 'click',
        values: [{ type: 'state', value: 'close' }]
      })
    }
  }

  return (
    <ClientOnly>
      <ClickAwayListener onClickAway={handleCloseTooltip}>
        <Tooltip
          title={props.title}
          role='tooltip'
          PopperProps={{ disablePortal: true }}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          open={isTooltipOpen}
          onClose={handleCloseTooltip}
          arrow>
          <InfoIconContainer
            data-testid='tooltip-icon'
            onClick={isTooltipOpen ? handleCloseTooltip : handleOpenTooltip}>
            <InfoIcon />
          </InfoIconContainer>
        </Tooltip>
      </ClickAwayListener>
    </ClientOnly>
  )
}
